import { render, staticRenderFns } from "./addTicket.vue?vue&type=template&id=000c5214&scoped=true&"
import script from "./addTicket.vue?vue&type=script&lang=js&"
export * from "./addTicket.vue?vue&type=script&lang=js&"
import style0 from "./addTicket.vue?vue&type=style&index=0&id=000c5214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c5214",
  null
  
)

export default component.exports